/* eslint-disable func-style */
export const SELECTORS = {
    QUANTITY: 'quantity-input',
    DECREASE: 'quantity-input__decrease',
    INCREASE: 'quantity-input__increase',
    NUMBER: 'quantity-input__number',
    INPUT: 'quantity-input__input',
  };
  
  export function updateInput(input, value) {
    input.value = value;
  }
  
  export function updateQuantityNumber(input) {
    const $numberElement = $(input).parent().find(`.${SELECTORS.NUMBER}`);
    $numberElement[0].textContent = input.value;
  }
  
  export function initInputs(element) {
    const elements = element
      ? element.querySelectorAll(`.${SELECTORS.QUANTITY}`) : document.querySelectorAll(`.${SELECTORS.QUANTITY}`);
  
    elements.forEach((element) => {
      const numberElement = element.querySelector(`.${SELECTORS.NUMBER}`);
      const decreaseElement = element.querySelector(`.${SELECTORS.DECREASE}`);
      const increaseElement = element.querySelector(`.${SELECTORS.INCREASE}`);
      const inputElement = element.querySelector(`.${SELECTORS.INPUT}`);
  
      function updateNumber() {
        numberElement.textContent = inputElement.value;
      }
  
      function getMax() {
        const customMax = Number(element.dataset.max);
        const minMaxifyMax = Number(inputElement.getAttribute('mm-max'));
        const inputMax = Number(inputElement.max);
  
        if (customMax) {
          if (minMaxifyMax) {
            return minMaxifyMax < customMax ? minMaxifyMax : customMax;
          }
  
          return customMax;
        }
  
        return minMaxifyMax || inputMax;
      }
  
      function getMin() {
        return inputElement.getAttribute('mm-min') || inputElement.min;
      }
  
      const updateQuantity = (number) => () => {
        const value = Number(inputElement.value) + number;
  
        const min = getMin();
        const max = getMax();
  
  
        if (value < Number(inputElement.value) && value >= min) {
          updateInput(inputElement, value);
          inputElement.dispatchEvent(new Event('change'));
        } else if (value >= min && value <= max) {
          updateInput(inputElement, value);
          inputElement.dispatchEvent(new Event('change'));
        }
      };
  
      decreaseElement.addEventListener('click', updateQuantity(-1));
      increaseElement.addEventListener('click', updateQuantity(1));
      inputElement.addEventListener('change', updateNumber);
  
      numberElement.textContent = inputElement.value;
    });
  }
  